import { render, staticRenderFns } from "./editControll.vue?vue&type=template&id=65d2c13b&"
import script from "./editControll.vue?vue&type=script&lang=js&"
export * from "./editControll.vue?vue&type=script&lang=js&"
import style0 from "./editControll.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports